import { useDispatch } from 'react-redux';
import { standardEventHandler } from 'actions/eventHandler.actions';
import React from 'react';

export const withEventHandler = Cmp => {
  const WithEventHandlerHoC = props => {
    const dispatch = useDispatch();

    function eventHandler(name, additionalData, eventOpts) {
      dispatch(standardEventHandler(name, additionalData, eventOpts));
    }

    return <Cmp {...props} eventHandler={eventHandler} />;
  };

  return WithEventHandlerHoC;
};
